module.exports = __webpack_public_path__ + "static/img/banner01.9360fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner01.jpg
// module id = TMun
// module chunks = 1